export default {
  googleClientId: '811956007885-gbqnf78ok93oa18bqq561jmlf355a1vu.apps.googleusercontent.com',
};
